// extracted by mini-css-extract-plugin
export default {"card":"Card1_card__eHz0Y","image":"Card1_image__c9qtT","overlay":"Card1_overlay__WexjH","heading":"Card1_heading__DzE01","title":"Card1_title__CLY-t","text":"Card1_text__+1aLn"};